import { createResource, type RouteResourceResponse } from 'react-resource-router';

import { getMuteDetail, getQuietHoursDetail } from '../endpoints';

// Redefined here since it is not exported from RRR.
type ResourceDependencies = {
	[type: string]: RouteResourceResponse;
};

const createMuteResource = (
	checkConsolidationOnRouteDependency?: (dependencies: ResourceDependencies) => boolean,
	depends?: string[],
) =>
	createResource({
		type: 'muteResource',
		getKey: () => 'muteResource',
		getData: ({ dependencies, match }) => {
			const targetAccountId = match.params?.targetAccountId;
			const isConsolidated = checkConsolidationOnRouteDependency
				? // @ts-ignore - Type 'undefined' is not assignable to type 'RouteResourceResponse'.n
					// This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
					checkConsolidationOnRouteDependency(dependencies)
				: true;
			if (!isConsolidated) {
				return null;
			}
			return getMuteDetail(targetAccountId);
		},
		isBrowserOnly: true,
		depends,
	});

const createQuietHoursResource = (
	checkConsolidationOnRouteDependency?: (dependencies: ResourceDependencies) => boolean,
	depends?: string[],
) =>
	createResource({
		type: 'quietHoursResource',
		getKey: () => 'quietHoursResource',
		getData: ({ dependencies, match }) => {
			const targetAccountId = match.params?.targetAccountId;
			const isConsolidated = checkConsolidationOnRouteDependency
				? // @ts-ignore - Type 'undefined' is not assignable to type 'RouteResourceResponse'.
					// This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
					checkConsolidationOnRouteDependency(dependencies)
				: true;

			if (!isConsolidated) {
				return null;
			}
			return getQuietHoursDetail(targetAccountId);
		},
		isBrowserOnly: true,
		depends,
	});

const muteResource = createMuteResource();
const quietHoursResource = createQuietHoursResource();

export { createQuietHoursResource, createMuteResource, muteResource, quietHoursResource };
